import EvaluationListDto from "../../dto/EvaluationListDto";

export default class EvaluationTermUpdateRequest {
  evaluationList = [];
  constructor(datas) {
    datas.forEach(data => {
      const evaluationListDto = new EvaluationListDto(data);
      this.evaluationList.push(evaluationListDto);
    });
  }
}
